import styled from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const TooltipContainer = styled.div`
  background: ${ct({ Dark: Colors.Black, Light: Colors.Black })};
  padding: 5px 10px;
  color: ${ct({ Dark: Colors.White, Light: Colors.White })};
  border-radius: 4px;
`;
